import { RouterProvider } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { router } from "./routes";

/**
 * App root: the auth session provider wrapping the data router. The TanStack
 * Query client + StrictMode + global styles are mounted one level up in
 * `main.tsx`.
 */
export function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}
